import React from "react";
import ReactDOM from "react-dom";

import { SharedCxProvider } from "./context/SharedCx";
import App from "./App";

import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

ReactDOM.render(
  <React.StrictMode>
    <SharedCxProvider>
      <App />
    </SharedCxProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
